import { render, staticRenderFns } from "./Powder.vue?vue&type=template&id=08cf89b5&scoped=true&"
import script from "./Powder.vue?vue&type=script&lang=js&"
export * from "./Powder.vue?vue&type=script&lang=js&"
import style0 from "./Powder.vue?vue&type=style&index=0&id=08cf89b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf89b5",
  null
  
)

export default component.exports